import './assets/styles/main.scss';

import ErrorBoundary from 'components/ErrorBoundary';
import HttpProvider from 'providers/HttpProvider';
import { LogProvider } from 'providers/LogsProvider';
import { PreviewProvider } from 'providers/PreviewProvider';
import { ProgressProvider } from 'providers/ProgressProvider';
import Routes from 'Routes';
import { SessionProvider } from 'providers/SessionProvider';
import { SurveyProvider } from 'providers/SurveyProvider';
import { ThemeProvider } from 'providers/ThemeProvider';
import { datadogRum } from '@datadog/browser-rum';
import { BrowserRouter } from 'react-router-dom';

function App() {
    // let Originurl = window.location.origin.toString();
    // if (!Originurl.includes('localhost')) {
    //     datadogRum.init({
    //         applicationId: 'bf6d9bc0-5e46-492f-b95e-8ee3a50ed4ba',
    //         clientToken: 'pub725c73283c7fa7dd04e558c1bbeca02f',
    //         site: 'datadoghq.com',
    //         service: process.env.REACT_APP_NAME,
    //         env: process.env.REACT_APP_ENV,
    //         // Specify a version number to identify the deployed version of your application in Datadog
    //         // version: '1.0.0',
    //         sampleRate: 100,
    //         sessionReplaySampleRate: 100,
    //         trackInteractions: true,
    //         trackResources: true,
    //         trackLongTasks: true,
    //         defaultPrivacyLevel: 'allow'
    //     });
    // }
    return (
        <ErrorBoundary>
            <BrowserRouter basename={`/${process.env.REACT_APP_NAME}`}>
                <ThemeProvider>
                    <ProgressProvider>
                        <SessionProvider>
                            <SurveyProvider>
                                <LogProvider>
                                    <PreviewProvider>
                                        <HttpProvider>
                                            <Routes />
                                        </HttpProvider>
                                    </PreviewProvider>
                                </LogProvider>
                            </SurveyProvider>
                        </SessionProvider>
                    </ProgressProvider>
                </ThemeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
